import { CSSObject } from '@emotion/react'
import { colors } from '@opallabs/spectrum'
import { AssignmentStatus } from './types'

// Returns background colors based on Assignment Status
export const backgroundByStatus = (
  assignmentStatus: AssignmentStatus
): CSSObject => {
  switch (assignmentStatus) {
    case AssignmentStatus.Default:
      return {
        backgroundColor: colors.n10.base,
        '&:hover': { backgroundColor: colors.n9.base },
      }
    case AssignmentStatus.Active:
      return {
        backgroundColor: colors['pp-blue'].base,
        '&:hover': { backgroundColor: colors['pp-blue']['base-hover'] },
      }
    case AssignmentStatus.New:
      return {
        backgroundColor: colors['pp-yellow'].base,
        '&:hover': { backgroundColor: colors['pp-yellow']['base-hover'] },
      }
    case AssignmentStatus.Warning:
      return {
        backgroundColor: colors['pp-red'].base,
        '&:hover': { backgroundColor: colors['pp-red']['base-hover'] },
      }
    default:
      return {
        backgroundColor: colors.n10.base,
        '&:hover': { backgroundColor: colors.n9.base },
      }
  }
}
